// extracted by mini-css-extract-plugin
export default {"layout":"Layout__layout__ZLw0K","content":"Layout__content__w1trn","footer":"Layout__footer__E4hlA","buttonText":"Layout__buttonText__djVHc","navLinks":"Layout__navLinks__KvAOQ"};